import { useQuery } from "@tanstack/react-query";
import { getContentBlockerTemplateMetaData } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
function useContentBlockerTemplateMetaData(isEnabled = true, refetchOnMount = true, filterIdentifiers, includeDeleted = false) {
    const { rcbAuthenticationStore } = useStores();
    const templateMetaQuey = useQuery(QueryKeys.getContentBlockerMeta(filterIdentifiers, includeDeleted), ({ signal })=>{
        return getContentBlockerTemplateMetaData({
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                filterIdentifiers: filterIdentifiers?.join(",") || "",
                includeDeleted
            }
        });
    }, {
        enabled: isEnabled,
        refetchOnMount
    });
    return templateMetaQuey;
}
export { useContentBlockerTemplateMetaData };
